import React from 'react'

import './loader.scss'

const Loader = () => {
  return (
    <div className="loader">
      <div className="loader-bounceball" />
      <div className="loader-text">Loading...</div>
    </div>
  )
}

export default Loader
